import styled from "@emotion/styled";
import { Box, LinearProgress, Typography } from "@mui/material";
import useProposalCreation from "./useProposalCreation";

const ColorLinearProgress = styled(LinearProgress)({
  height: "0.6em",
  backgroundColor: "#e0e0e0",
  "& .MuiLinearProgress-bar": {
    background: "linear-gradient(90deg, #38ce35 0, #18c6b1 100%)",
  },
});

const KYCFailed = ({ errorMessage, goToPortal, goBackToCreateQuotePage }) => (
  <>
    <Typography variant="h6" align="center">
      Oh, KYC Verification Failed. Go to Portal to verify.
    </Typography>
    <Typography variant="body2" align="center" color={"error.main"}>
      {errorMessage}
    </Typography>
    <Box m={2}>
      <button className="payment-btn" type="button" onClick={goToPortal}>
        Go to KYC Portal
      </button>
      <button
        className="pay-btn"
        type="button"
        onClick={goBackToCreateQuotePage}
      >
        Go back
      </button>
    </Box>
  </>
);
const KYCException = ({
  errorMessage,
  retryKYCProcess,
  isLoading,
  goBackToCreateQuotePage,
}) => (
  <>
    <Typography variant="h6" align="center">
      Oh, KYC Verification Failed. Please try again.
    </Typography>
    <Typography variant="body2" align="center" color={"error.main"}>
      {errorMessage}
    </Typography>
    <Box mt={2}>
      <button
        className="payment-btn"
        type="button"
        disabled={isLoading}
        onClick={retryKYCProcess}
      >
        Retry KYC Verification
      </button>
      <button
        className="pay-btn"
        type="button"
        onClick={goBackToCreateQuotePage}
      >
        Go back
      </button>
    </Box>
  </>
);

const ProposalFailed = ({ errorMessage, goBackToCreateQuotePage }) => (
  <>
    <Typography variant="h6" align="center">
      Oh, Something went wrong in the proposal form. Please check your details
      again.
    </Typography>
    <Typography variant="body2" align="center" color={"error.main"}>
      {errorMessage}
    </Typography>
    <Box mt={2}>
      <button
        className="payment-btn"
        type="button"
        onClick={goBackToCreateQuotePage}
      >
        Go back to proposal form
      </button>
    </Box>
  </>
);

const ProposalCreation = () => {
  const {
    progress,
    isLoading,
    kycVerificationStatus,
    createQuoteProposalStatus,
    kycProcess,
    goToPortal,
    goBackToCreateQuotePage,
    step,
    KYCStatus,
    CreateQuoteProposalStatus,
    goToPaymentPage,
    retryCreateProposal,
    kycErrorMessage,
    proposalCreationErrorMessage,
  } = useProposalCreation();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
        justifyContent: "center",
      }}
    >
      <Box sx={{ width: "100%" }}>
        <ColorLinearProgress variant="determinate" value={progress} />
      </Box>

      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          flexGrow: 1,
          alignItems: "center",
          justifyContent: "center",
          p: 2,
        }}
      >
        {isLoading && (
          <>
            <Typography variant="h6" align="center">
              {step === 0 ? "Verifying KYC" : "Generating proposal"}
            </Typography>
          </>
        )}
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          marginTop={2}
        >
          {kycVerificationStatus === KYCStatus.FAILED &&
            createQuoteProposalStatus !== CreateQuoteProposalStatus.FAILED && (
              <KYCFailed
                errorMessage={kycErrorMessage}
                goToPortal={goToPortal}
                goBackToCreateQuotePage={goBackToCreateQuotePage}
              />
            )}
          {kycVerificationStatus === KYCStatus.ERROR && (
            <>
              <KYCException
                errorMessage={kycErrorMessage}
                retryKYCProcess={kycProcess}
                isLoading={isLoading}
                goBackToCreateQuotePage={goBackToCreateQuotePage}
              />
            </>
          )}
          {createQuoteProposalStatus === CreateQuoteProposalStatus.FAILED && (
            <ProposalFailed
              errorMessage={proposalCreationErrorMessage}
              goBackToCreateQuotePage={goBackToCreateQuotePage}
            />
          )}
          {createQuoteProposalStatus === CreateQuoteProposalStatus.ERROR && (
            <>
              <Typography variant="h6" align="center">
                Oh, Proposal Creation Failed. Please try again.
              </Typography>
              <Box mt={2}>
                <button
                  className="payment-btn"
                  type="button"
                  disabled={isLoading}
                  onClick={retryCreateProposal}
                >
                  Retry Proposal Creation
                </button>
              </Box>
            </>
          )}
          {kycVerificationStatus === KYCStatus.VERIFIED &&
            (createQuoteProposalStatus === CreateQuoteProposalStatus.SUCCESS ||
              createQuoteProposalStatus ===
                CreateQuoteProposalStatus.ALREADY_GENERATED) && (
              <>
                <Typography variant="h6" align="center">
                  Congratulations! All steps are completed.
                </Typography>
                <Box mt={2}>
                  <button
                    className="payment-btn"
                    type="button"
                    // disabled={isLoading}
                    onClick={goToPaymentPage}
                  >
                    Proceed to Payment Page
                  </button>
                </Box>
              </>
            )}
        </Box>
      </Box>
    </Box>
  );
};

export default ProposalCreation;
